export default __webpack_public_path__ + "static/tom-2943a78787b5c29213f0446263bb52fe.png";